<template>
  <div>
    <div v-if="saving || loading" class="overlay"></div>
    <layout menu-item="3">

      <div class="wh100">

        <div layout="row bottom-left" class="tools w100" style="padding: 0.5rem;">
          <select class="form-control" @change="loadMapData($event.target.value)">
            <option v-for="city in cities" :value="city.cityKey">{{city.cityName}}</option>
          </select>
          <button :class="getTabClass('edit')" @click="setMode('edit')">Edit</button>
          <button :class="getTabClass('app')" @click="setMode('app')">iPad</button>
          <button :class="getTabClass('hq')" @click="setMode('hq')">HQ</button>

          <div layout="row bottom-spread" class="w100" style="">

            <div layout="row center-left" style="min-width:220px; width:220px;">
              <div layout="column center-left">
                <span class="label">Enter Radius</span>
                <input type="number" class="form-control" style="color:#0000ff; border-color:#0000ff" v-model.number="enterRadius">
              </div>

              <div layout="column center-left">
                <span class="label">Exit Radius</span>
                <input type="number" class="form-control" style="color:#ff0000; border-color:#ff0000" v-model.number="exitRadius">
              </div>

              <div layout="column center-left">
                <span class="label">WP Radius</span>
                <input type="number" class="form-control" style="color:#20BB2C; border-color:#20BB2C" v-model.number="waypointRadius">
              </div>
            </div>



            <div layout="row center-left" style="min-width:220px; width:220px;">
             <div style="margin-right: 0.5rem"><strong>WP2</strong></div>
              <div layout="column center-left">
                <span class="label">Enter Radius</span>
                <input type="number" class="form-control" style="color:#0000ff; border-color:#0000ff" v-model.number="enterRadiusWP2">
              </div>

              <div layout="column center-left">
                <span class="label">Exit Radius</span>
                <input type="number" class="form-control" style="color:#ff0000; border-color:#ff0000" v-model.number="exitRadiusWP2">
              </div>

              <div layout="column center-left">
                <span class="label">WP Radius</span>
                <input type="number" class="form-control" style="color:#20BB2C; border-color:#20BB2C" v-model.number="waypointRadiusWP2">
              </div>
            </div>


            <div layout="row bottom-center" style="width:250px;">
              <div layout="column center-left">
                <span class="label">Quizdauer</span>
                {{quizTime}} Sek
              </div>

              <div layout="column-left" style="margin-left: 1rem">
                <div class="label">Strecke</div>
                <div>{{Math.round(speed * 0.277777778 * quizTime)}} m</div>
              </div>

              <div layout="column center-left">
                <span class="label">Geschwindigkeit</span>
                <select class="form-control" v-model="speed" style="width:8rem">
                  <option v-for="speed in speeds" :value="speed">{{speed}} KM/H</option>
                </select>
              </div>
            </div>


          </div>


          <button class="btn btn-danger" self="right" style="margin-right: 0.5rem" @click="save">Speichern</button>
        </div>


        <google-map ref="map"
                    :mode="mode"
                    :speed="speed"
                    :enterRadius="enterRadius"
                    :exitRadius="exitRadius"
                    :waypointRadius="waypointRadius"
                    :enterRadiusWP2="enterRadiusWP2"
                    :exitRadiusWP2="exitRadiusWP2"
                    :waypointRadiusWP2="waypointRadiusWP2"
                    :quizTime="quizTime"
        />

      </div>

    </layout>
  </div>
</template>

<script>

  import GoogleMap from "./GoogleMap";
  import Backend from '@/Backend';

  export default {
    components: {GoogleMap},
    name: "maps",
    data() {
      return {
        loading: true,
        saving: false,
        enterRadius: 0,
        exitRadius: 0,
        waypointRadius: 0,
        enterRadiusWP2: 0,
        exitRadiusWP2: 0,
        waypointRadiusWP2: 0,
        quizTime: 0,
        cities: [],
        speeds: [30, 50, 70, 100],
        mode: 'edit',
        cityKey: 'mannheim',
        mapData: null,
        settings: {},
        speed: 30
      }
    },
    computed: {
        quizDistance: function() {
          return 10;
        }

    },
    methods: {
      getTabClass(tab) {
        return {
          btn: true,
          'btn-sm': true,
          'btn-secondary': this.mode != tab,
          'btn-primary': this.mode == tab
        }
      },
      setMode(mode) {
        this.mode = mode;
        this.$refs.map.setMode(mode);
      },
      save() {

        this.saving = true;
        const data = this.$refs.map.getMapData().then((data) => {
          data.enterRadius = this.enterRadius;
          data.exitRadius = this.exitRadius;
          data.waypointRadius = this.waypointRadius;

          data.enterRadiusWP2 = this.enterRadiusWP2;
          data.exitRadiusWP2 = this.exitRadiusWP2;
          data.waypointRadiusWP2 = this.waypointRadiusWP2;

          Backend.instance.saveMapData(this.cityKey, data)
            .then(() => {
              this.saving = false;
            });
        });
      },
      loadMapData(key) {
        this.cityKey = key;
        this.loading = true;

        this.speed = this.speeds[0];

        Backend.instance.getMapData(key)
          .then(data => {
            this.mapData = data;
            this.loading = false;

            this.enterRadius = data.enterRadius || 100;
            this.exitRadius = data.exitRadius || 100;
            this.waypointRadius = data.waypointRadius || 50;

            this.enterRadiusWP2 = data.enterRadiusWP2 || 100;
            this.exitRadiusWP2 = data.exitRadiusWP2 || 100;
            this.waypointRadiusWP2 = data.waypointRadiusWP2 || 50;

            this.$refs.map.setMapData(data);
          })
          .catch(e => {
          });
      }
    },
    mounted() {
      this.loading = true;

      Backend.instance.getSettings()
        .then((data) => {
          this.settings = data;
          this.quizTime = data.settings.quiz.time;
          // this.enterRadius = data.settings.map.enterRadius;
          // this.exitRadius = data.settings.map.exitRadius;
          return Backend.instance.getMaps();
        })
        .then((data) => {
          this.cities = data;
          this.cities.sort((a, b) => a.cityKey.localeCompare(b.cityKey));
          this.loadMapData(data[0].cityKey);
        });
    }
  }
</script>

<style scoped>

  .tools {
    /*position: absolute;*/
    /*height: 40px;*/
    /*top:30px;*/
  }

  button {
    margin-left: 1rem;
  }

  select {
    max-width: 15rem;
  }

  input[type=number] {
    width: 4.5rem;
    margin-right: 0.3rem;
  }

  input, select {
    padding: 0.3rem;
  }

  .tab-selected {
    pointer-events: none;
  }

  .label {
    font-size: 0.8rem;
  }

  .overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.6);
  }

  .pac-card {
    margin: 10px 10px 0 0;
    border-radius: 2px 0 0 2px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    outline: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    background-color: #fff;
    position: absolute;
  }

</style>



// WEBPACK FOOTER //
// src/components/maps/Maps.vue